<!-- items: {{ jobs.items | json }}-->

<div infiniteScroll [infiniteScrollDistance]="0.5" [fromRoot]="true" (scrolled)="onScrolled()">
  <div class="block job" *ngFor="let job of jobs.items">
    <div class="job-top d-flex align-items-center">
      <div class="author d-flex align-items-center">
        <div class="avatar rounded-circle">
          <app-avatar [src]="job.user.icon" [placeholder]="job.user | initials" class="ava"></app-avatar>
        </div>
        <div>
          <div class="name d-flex align-items-center"> {{ job.user?.name }} </div>
          <div class="position"> {{ job.user?.type_name }} </div>
        </div>
      </div>
      <div class="ml-auto">
        <a href="#" class="job-edit" *ngIf="isOwner(job)" (click)="onEditJob(job); false">Edit</a>
      </div>
      <!--      <div class="job-date ml-auto">-->
      <!--        {{ job.user?.online_str }}-->
      <!--      </div>-->
    </div>
    <div class="job-title"> {{ job.name }} {{ job.user?.name }} </div>
    <div class="job-description" *ngIf="job.description"> {{ job.description }} </div>
    <br />
    <div class="job-data">
      <ng-container *ngIf="job.user?.location?.city?.name; let city">
        <ng-container *ngIf="job.user?.location?.country?.name; let country">
          <div class="job-data-item" *ngIf="city && country">
            <div class="icon">
              <svg viewBox="0 0 20 20">
                <use href="#location" />
              </svg>
            </div>
            {{ city }}, {{ country }}
          </div>
        </ng-container>
      </ng-container>
      <div class="job-data-item" *ngIf="job.children">
        <div class="icon">
          <svg viewBox="0 0 20 20">
            <use href="#student" />
          </svg>
        </div>
        Job for students
      </div>
      <div class="job-data-item" *ngIf="job.remote">
        <div class="icon">
          <svg viewBox="0 0 20 20">
            <use href="#work" />
          </svg>
        </div>
        Remote work
      </div>
      <div class="job-data-item" *ngIf="job.url">
        <div class="icon">
          <svg viewBox="0 0 20 20">
            <use href="#earth" />
          </svg>
        </div>
        <a [href]="job.url" target="_blank" *ngIf="job.url">{{ job.url }}</a>
      </div>
      <div class="job-actions">
        <ng-container *appHideForGuest>
          <a [href]="'mailto:'+job.email" *ngIf="!job.url && job.email" class="action"> Apply </a>

          <a [href]="job.url" target="_blank" *ngIf="job.url" class="action"> Apply </a>
        </ng-container>
      </div>
    </div>
  </div>
  <!-- TODO: [appVisibility] -->
  <app-loader-2 [style.visibility]="jobs.loading ? 'visible' : 'hidden'"></app-loader-2>
</div>
